import { datatypes, inputTypes } from "data/globalData";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";

export const tableColumns = {
	cost_type: {
		name: "Cost Type",
		key: "cost_type",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	annual_discounting_percent: {
		name: "Discounting % Annualy",
		key: "annual_discounting_percent",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	discounting_days: {
		name: "Discounting Days",
		key: "discounting_days",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	transit_plus_grn: {
		name: "Transit + Grn",
		key: "transit_plus_grn",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	no_of_days: {
		name: "No of Days",
		key: "no_of_days",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	discount_percent: {
		name: "Discount Percent",
		key: "discount_percent",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};
export const tableRowTypes = {
	before_discounting: {
		name: "Cost Before Discounting",
		key: "before_discounting",
	},
	after_discounting: {
		name: "Cost After Discounting",
		key: "after_discounting",
	},
};

export const postCostTableDefaultData = [
	{
		id: 1,
		cost_type: tableRowTypes.before_discounting.key,
		annual_discounting_percent: 0,
		discounting_days: 90,
		transit_plus_grn: 0,
		no_of_days: 90,
		discount_percent: 0,
		value: 0,
	},
	{
		id: 2,
		cost_type: tableRowTypes.after_discounting.key,
		annual_discounting_percent: 0,
		discounting_days: 90,
		transit_plus_grn: 0,
		no_of_days: 90,
		discount_percent: 0,
		value: 0,
	},
];

export const calculateCostBeforeDiscounting = (row, totalCost = 0) => {
	let value = totalCost;
	return {
		...row,
		value,
	};
};
export const calculateCostAfterDiscountingRow = (row, totalCost = 0) => {
	let no_of_days = parseInt(+(row[tableColumns.discounting_days.key] || 0) + +(row[tableColumns.transit_plus_grn.key] || 0)) ?? 0;
	let discount_percent = ((row[tableColumns.annual_discounting_percent.key] || 0) / 365) * (no_of_days || 0);
	let value = roundDecimalValueUptoTwoDigit(totalCost - totalCost * (discount_percent / 100));
	return {
		...row,
		no_of_days,
		discount_percent,
		value,
	};
};
